var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('BaseInventory',{attrs:{"categoryId":"2","categoryName":"Downhole Sensor","categorySectionIcon":"fa-bolt","useActive":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }